import { render, staticRenderFns } from "./teacherAuth.vue?vue&type=template&id=0137625c&scoped=true&"
import script from "./teacherAuth.vue?vue&type=script&lang=js&"
export * from "./teacherAuth.vue?vue&type=script&lang=js&"
import style0 from "./teacherAuth.vue?vue&type=style&index=0&id=0137625c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137625c",
  null
  
)

export default component.exports